<template>
  <div>
    <div class="card shadow">
      <a id="button"></a>
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $t('message.edit') }} {{ $t('message.compteRenduOperatoire') }}
          </h3>
        </div>
      </div>

      <div class="card-body">

        <h3 class="text-center"> {{$t('message.infoConsultation')}}
        </h3>
        <b-form v-if="show">
          <b-container>
            <b-row>
              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="institution-group"
                    :label="$t('message.etablissementIntervention')"
                    label-for="institution"
                >
                  <select id="institution" v-model="$v.form.etablissement_id.$model"
                          @change="clearErrorField('etablissement_id')"
                          class="form-control is-invalid retirerBordure"
                          required
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.etablissement_id.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('etablissement_id')" class="invalid">
                                    {{getErrorsField('etablissement_id')}}
                                    </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="typeIntervention-group"
                    :label="$t('message.typeIntervention')"
                    label-for="typeIntervention-propose"
                >
                  <b-form-input
                      id="occupation"
                      v-model="$v.form.type_intervention.$model"
                      :state="$v.form.type_intervention.$dirty ? !(errorshasField('type_intervention') || $v.form.type_intervention.$error) : null"
                      @focus="clearErrorField('profession')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="errorshasField('type_intervention')">
                    {{ getErrorsField('type_intervention') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-if="!$v.form.type_intervention.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="clinicalHistory-group"
                    :label="$t('message.clinicalHistory')"
                    label-for="clinicalHistory"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.histoire_clinique.$model"
                      :state="$v.form.histoire_clinique.$dirty ? !(errorshasField('histoire_clinique') || $v.form.histoire_clinique.$error) : null"
                      @focus="clearErrorField('histoire_clinique')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('histoire_clinique')">
                    {{ getErrorsField('histoire_clinique') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>

                <b-form-group
                    id="consultation-group"
                    :label="$t('message.dateIntervention')"
                    label-for="consultation"
                    description="">
                  <vue-ctk-date-time-picker class="border-dark" v-model="date_intervention"></vue-ctk-date-time-picker>

                  <b-form-invalid-feedback v-if="!$v.form.date_intervention.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('date_intervention')">
                    {{ getErrorsField('date_intervention') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="chirugiens-group"
                    :label="$t('message.chirugiens')"
                    label-for="chirugiens"
                >
                  <select id="chirugiens" v-model="$v.form.chirugiens.$model"
                          @change="clearErrorField('chirugiens')"
                          class="form-control is-invalid retirerBordure"
                          required
                          multiple
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mContributors" :key="item.id" :value="item.nom">
                      {{ item.nom }}
                    </option>
                  </select>
                  <span v-if="errorshasField('contributeurs')" class="invalid">
                                    {{getErrorsField('contributeurs')}}
                                    </span>
                  <span class="invalid" v-if="$v.form.chirugiens.$error"  >
                    {{ $t('message.requiredField') }}
                  </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <b-form-group
                    id="aide-group"
                    :label="$t('message.aide')"
                    label-for="aide"
                >
                  <select id="aide" v-model="$v.form.aides.$model"
                          @change="clearErrorField('aides')"
                          class="form-control is-invalid retirerBordure"
                          required
                          multiple
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mContributors" :key="item.id" :value="item.nom">
                      {{ item.nom }}
                    </option>
                  </select>
                  <span v-if="errorshasField('aides')" class="invalid">
                                    {{getErrorsField('aides')}}
                                    </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <b-form-group
                    id="circulant-group"
                    :label="$t('message.circulant')"
                    label-for="circulant"
                >
                  <select id="circulant" v-model="$v.form.circulants.$model"
                          @change="clearErrorField('circulants')"
                          class="form-control is-invalid retirerBordure"
                          required
                          multiple
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mContributors" :key="item.id" :value="item.nom">
                      {{ item.nom }}
                    </option>
                  </select>
                  <span v-if="errorshasField('circulants')" class="invalid">
                                    {{getErrorsField('circulants')}}
                                    </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="anesthesistes-group"
                    :label="$t('message.anesthesistes')"
                    label-for="anesthesistes"
                >
                  <select id="anesthesistes" v-model="$v.form.anesthesistes.$model"
                          @change="clearErrorField('anesthesistes')"
                          class="form-control is-invalid retirerBordure"
                          required
                          multiple
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mContributors" :key="item.id" :value="item.nom">
                      {{ item.nom }}
                    </option>
                  </select>
                  <span v-if="errorshasField('anesthesistes')" class="invalid">
                                    {{getErrorsField('anesthesistes')}}
                                    </span>

                  <span class="invalid" v-if="$v.form.anesthesistes.$error">
                    {{ $t('message.requiredField') }}
                  </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="typeAnesthesie-group"
                    :label="$t('message.typeAnesthesie')"
                    label-for="typeAnesthesie-propose"
                >
                  <b-form-input
                      id="typeAnesthesie"
                      v-model="$v.form.type_anesthesie.$model"
                      :state="$v.form.type_anesthesie.$dirty ? !(errorshasField('type_anesthesie') || $v.form.type_anesthesie.$error) : null"
                      @focus="clearErrorField('type_anesthesie')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="errorshasField('type_anesthesie')">
                    {{ getErrorsField('type_anesthesie') }}
                  </b-form-invalid-feedback>
                  <span class="invalid" v-if="$v.form.type_anesthesie.$error">
                    {{ $t('message.requiredField') }}
                  </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="descriptionIntervention-group"
                    :label="$t('message.descriptionIntervention')"
                    label-for="descriptionIntervention"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.description.$model"
                      :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                      @focus="clearErrorField('description')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('description')">
                    {{ getErrorsField('description') }}
                  </b-form-invalid-feedback>
                  <span class="invalid" v-if="$v.form.description.$error">
                    {{ $t('message.requiredField') }}
                  </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="traitementPostOperatoire-group"
                    :label="$t('message.traitementPostOperatoire')"
                    label-for="traitementPostOperatoire"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.traitement_post_operatoire.$model"
                      :state="$v.form.traitement_post_operatoire.$dirty ? !(errorshasField('traitement_post_operatoire') || $v.form.traitement_post_operatoire.$error) : null"
                      @focus="clearErrorField('traitement_post_operatoire')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('traitement_post_operatoire')">
                    {{ getErrorsField('traitement_post_operatoire') }}
                  </b-form-invalid-feedback>
                  <span class="invalid" v-if="$v.form.traitement_post_operatoire.$error">
                    {{ $t('message.requiredField') }}
                  </span>
                </b-form-group>
              </b-col>

            </b-row>

            <b-row class="justify-content-sm-center">
              <b-button @click="onSubmit" variant="primary" v-if="can">
                {{ $t('message.edit') }}
              </b-button>
            </b-row>
          </b-container>
        </b-form>

      </div>
    </div>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import {mapGetters} from "vuex";
import _ from "lodash";
import moment from "moment";
import AppConfig from "@/constants/AppConfig";
import {required} from "vuelidate/lib/validators";
import SlimSelect from "slim-select";

export default {
  name: "Edit",

  components: {
    editor: Editor
  },

  computed: {
    ...mapGetters([
      "practitioners",
      "controlDoctors",
      "compteRendu",
      'errors',
      'hasAdminRole',
      "userInstitutions",
      'hasMedecinControleRole',
      'hasAssistante',
      "hasSouscripteurRole",
      "hasPatientRole",
      'hasPraticienRole',
      'hasGestionnaireRole']),

    form: function() {
      let self = this;
      let compte = this.compteRendu;
      let item = _.omit(compte,[
        'chirugiens',
        'aides',
        'dossier',
        'etablissement',
      ]);
      item.chirugiens  = [];
      item.aides = [];
      item.circulants = [];
      item.anesthesistes = [];
      item.date_intervention = moment(compte.date_intervention).format('YYYY-MM-DD HH:mm')
      self.date_intervention = compte.date_intervention;
      let chirugiens = (_.pick(compte,'chirugiens')).chirugiens;
      if(!_.isUndefined(chirugiens) && !_.isNil(chirugiens)){
        item.chirugiens = chirugiens.split(', ') ;
      }
      _.forEach(item.chirugiens,function (chirugien){
        if (_.isUndefined(_.find(self.mContributors,function (contributeur){
          return contributeur.nom == chirugien;
        }))){
          self.mContributors.push({nom:chirugien})
        }
      })

      let circulants = (_.pick(compte,'circulants')).circulants;
      if(!_.isUndefined(circulants) && !_.isNil(circulants)){
        item.circulants = circulants.split(', ') ;
      }
      _.forEach(item.circulants,function (circulant){
        if (_.isUndefined(_.find(self.mContributors,function (contributeur){
          return contributeur.nom == circulant;
        }))){
          self.mContributors.push({nom:circulant})
        }
      })

      let anesthesistes = (_.pick(compte,'anesthesistes')).anesthesistes;
      if(!_.isUndefined(anesthesistes) && !_.isNil(anesthesistes)){
        item.anesthesistes = anesthesistes.split(', ') ;
      }
      _.forEach(item.anesthesistes,function (anesthesiste){
        if (_.isUndefined(_.find(self.mContributors,function (contributeur){
          return contributeur.nom == anesthesiste;
        }))){
          self.mContributors.push({nom:anesthesiste})
        }
      })

      let aides = (_.pick(compte,'aides')).aides;
      if(!_.isUndefined(aides)&& !_.isNil(aides)){
        item.aides = aides.split(', ') ;
      }
      _.forEach(item.aides,function (aide){
        if (_.isUndefined(_.find(self.mContributors,function (contributeur){
          return contributeur.nom == aide;
        }))){
          self.mContributors.push({nom:aide})
        }
      })

      return item;
    },

    mInstitutions: function () {
      let iArray = [];

      _.forEach(_.orderBy(this.userInstitutions, ['created_at'], ['desc']), function (institution) {
        let i = {};

        i.nom = institution.name;
        i.description = (!_.isNull(institution.description)? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
        i.date = moment(institution.created_at).format('DD-MM-YYYY');
        i.id = institution.id;
        i.slug = institution.slug;

        iArray.push(i);
      });

      return iArray;
    },

    mPractitioners: function() {
      let pArray = [];

      _.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
        let p = {};
        if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) ){
          let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
          prenom =  prenom.toLowerCase();
          p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          // p.id = practitioner.user.id;
          if (p.nom.length >0){
            pArray.push(p);
          }
        }

      });

      return pArray;
    },

    mDoctors: function() {
      let dArray = [];

      _.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
        let d = {};
        if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
          let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
          prenom =  prenom.toLowerCase();
          d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          // d.id = doctor.user.id;
          if (d.nom.length >0){
            dArray.push(d);
          }
        }

      });

      return dArray;
    },

    mContributors:function () {
      let cArray = [];
      return cArray.concat(this.mDoctors,this.mPractitioners);
    },

    can:function (){
      return this.compteRendu.canUpdate;
    }

  },
  data() {
    return {
      date_intervention:'',
      compte_rendu: this.$route.params.compteRendu,
      tinyKey: AppConfig.tinyMceKey,
      plugins: [
        'advlist autolink lists  image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table'
      ],
      toolbar: 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
      file_id: this.$route.params.file,

      paginationOptions: {
        enabled: true,
        mode: 'records',
        perPageDropdown: [3, 6, 10]
      },

      enabled: {enabled: true},

      sort: {
        enabled: true,
        initialSortBy: {field: 'date', type: 'desc'}
      },

      show: true,
    }
  },

  methods: {
    getCompteRendu() {
      let args = {
        compte_rendu_operatoire: this.compte_rendu
      };

      this.$store.dispatch("getCompteRendu", { args });
    },

    getDoctors() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getControlDoctors', { args : args });
    },

    getPractitioners() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getPractitioners', { args : args });
    },


    getUserInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getUserInstitutions', {args: args});
    },

    getInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getInstitutions', {args: args});
    },

    onSubmit: function (evt) {
      evt.preventDefault();
      this.$v.form.$touch();

      if (!this.$v.form.$invalid){
        let args = this.$v.form.$model;
        args.chirugiens = _.map(this.form.chirugiens).join(', ');
        args.aides = _.map(this.form.aides).join(', ');
        args.anesthesistes = _.map(this.form.anesthesistes).join(', ');
        args.circulants = _.map(this.form.circulants).join(', ');
        args.dossier_medical_id = this.form.dossier_medical_id;
        args.date_intervention = moment(this.date_intervention).format('YYYY-MM-DD HH:mm');

        args = _.pick(args,[
            'slug',
          'etablissement_id',
          'chirugiens',
          'aides',
          'anesthesistes',
          'circulants',
          'dossier_medical_id',
          'traitement_post_operatoire',
          'description',
          'histoire_clinique',
          'type_intervention',
          'type_anesthesie',
        ]);

        args.date_intervention = moment(this.date_intervention).format('YYYY-MM-DD HH:mm');

        let successMessage = this.$i18n.t('message.compteRendu.operatoireUpdated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('updateCompteRendu', {args: args, errorMessages, successMessage})

      }


      // let successMessage = this.$i18n.t('message.generalConsultationCreated');
      // let errorMessages = {
      //   generic: this.$i18n.t('message.genericError'),
      //   error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      // };
      //
      //
      // this.$store.dispatch('createGeneralConsultation', {args: args, errorMessages, successMessage})
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return '';
      }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch('clearErrorField', {field});

      this.getErrorsField(field);
    }
  },

  validations: {
    date_intervention:{required},
    form: {
      etablissement_id: {required},
      dossier_medical_id:{},
      type_intervention:{required},
      histoire_clinique:{required},
      date_intervention:{required},
      chirugiens:{required},
      aides:{},
      circulants:{},
      anesthesistes:{required },
      type_anesthesie:{required},
      description:{required},
      traitement_post_operatoire:{required},
    },

  },

  mounted() {
    this.getCompteRendu();

    // Fetch control doctor list
    this.getDoctors();

    // Fetch practitioner list
    this.getPractitioners();

    // Fetch user institution list
    this.getUserInstitutions();

    // Fetch institution list
    this.getInstitutions();

    new SlimSelect({
      select: '#institution',
      placeholder: 'Select institution',
      limit: 1
    });

    var chirugiens = new SlimSelect({
      select: '#chirugiens',
      placeholder: 'Select chirugiens',
      addable: function (value) {
        if (chirugiens.selected().length == 5) {
          return false;
        } else {
          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });

    var aide = new SlimSelect({
      select: '#aide',
      placeholder: 'Select aide',
      addable: function (value) {
        if (aide.selected().length == 5) {
          return false;
        } else {

          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });

    var circulant = new SlimSelect({
      select: '#circulant',
      placeholder: 'Select circulant',
      addable: function (value) {
        if (circulant.selected().length == 5) {
          return false;
        } else {

          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });

    var anesthesistes = new SlimSelect({
      select: '#anesthesistes',
      placeholder: 'Select circulant',
      addable: function (value) {
        if (anesthesistes.selected().length == 5) {
          return false;
        } else {

          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });
  }
}
</script>

<style scoped>
.invalid {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #f5365c
}
</style>